import { z } from 'zod';

import { SecretTypeEnum } from '@/shared/types/types.generated';
import { requiredString } from '@/shared/utils/validation';

export const createSecretInputSchema = z.object({
  secretType: z.nativeEnum(SecretTypeEnum),
  name: requiredString(),
  username: requiredString(),
  secretValue: requiredString(),
});
